module.exports = __webpack_public_path__ + "img/blurQr.52784724.png";